export default "__VITE_ASSET__BvJzM7ni__"